import { render, staticRenderFns } from "./EditIndividualPage.vue?vue&type=template&id=662dcac6&"
import script from "./EditIndividualPage.vue?vue&type=script&lang=js&"
export * from "./EditIndividualPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports